(() => {
  const DESKTOP = '(min-width: 990px)';
  const LIMIT = 5;

  function isDesktop() {
    return window.matchMedia(DESKTOP).matches;
  }

  function enhance(scope) {
    if (!isDesktop()) return;

    const root = scope && scope.querySelectorAll ? scope : document;
    const lists = [];

    if (root.matches && root.matches('.header__vertical-menu .mega-menu__list > li > ul.list-unstyled')) {
      lists.push(root);
    }

    root.querySelectorAll('.header__vertical-menu .mega-menu__list > li > ul.list-unstyled').forEach((list) => lists.push(list));

    lists.forEach((list) => {
      if (list.dataset.scMoreReady === 'true') return;

      const parent = list.parentElement;
      if (!parent || !parent.querySelector(':scope > .mega-menu__link--level-2')) return;

      const items = Array.from(list.children).filter((item) => item.tagName === 'LI' && !item.classList.contains('sc-mega-more-row'));
      if (items.length <= LIMIT) {
        list.dataset.scMoreReady = 'true';
        return;
      }

      items.slice(LIMIT).forEach((item) => {
        item.classList.add('sc-mega-extra-item');
        item.hidden = true;
      });

      const row = document.createElement('li');
      row.className = 'sc-mega-more-row';

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'sc-mega-more-toggle';
      button.setAttribute('aria-expanded', 'false');
      button.textContent = 'Daha Fazla Gör';

      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const expanded = button.getAttribute('aria-expanded') === 'true';
        items.slice(LIMIT).forEach((item) => {
          item.hidden = expanded;
        });

        button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        button.textContent = expanded ? 'Daha Fazla Gör' : 'Daha Az Gör';
      });

      row.appendChild(button);
      list.appendChild(row);
      list.dataset.scMoreReady = 'true';
    });
  }

  function scan() {
    enhance(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  const header = document.getElementById('header-group') || document.body;
  const observer = new MutationObserver((mutations) => {
    if (!isDesktop()) return;
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) enhance(node);
      });
    });
  });

  observer.observe(header, { childList: true, subtree: true });

  document.addEventListener('pointerenter', (event) => {
    if (!isDesktop()) return;
    if (event.target && event.target.closest && event.target.closest('.header__vertical-menu')) scan();
  }, true);
})();
